"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shoppingContextActions = void 0;
var AcceptNotification = _interopRequireWildcard(require("@ori-events/accept-notification"));
var AcceptNotificationFailed = _interopRequireWildcard(require("@ori-events/accept-notification-failed"));
var AddBackorderDemand = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddBackorderDemandFailed = _interopRequireWildcard(require("@ori-events/add-backorder-demand-failed"));
var AddBasketOffer = _interopRequireWildcard(require("@ori-events/add-basket-offer"));
var AddBasketOfferFailed = _interopRequireWildcard(require("@ori-events/add-basket-offer-failed"));
var AddCatalogueOffer = _interopRequireWildcard(require("@ori-events/add-catalogue-offer"));
var AddCatalogueOfferFailed = _interopRequireWildcard(require("@ori-events/add-catalogue-offer-failed"));
var AddCustomerOrder = _interopRequireWildcard(require("@ori-events/add-customer-order"));
var AddCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/add-customer-order-failed"));
var AddFreeShippingOffer = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer"));
var AddFreeShippingOfferFailed = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer-failed"));
var AddPersonalNutritionItems = _interopRequireWildcard(require("@ori-events/add-personal-nutrition-items"));
var AddPersonalNutritionItemsFailed = _interopRequireWildcard(require("@ori-events/add-personal-nutrition-items-failed"));
var AddPersonalSubscription = _interopRequireWildcard(require("@ori-events/add-personal-subscription"));
var AddPersonalSubscriptionFailed = _interopRequireWildcard(require("@ori-events/add-personal-subscription-failed"));
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailed = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var AddVoucher = _interopRequireWildcard(require("@ori-events/add-voucher"));
var AddVoucherFailed = _interopRequireWildcard(require("@ori-events/add-voucher-failed"));
var CancelBackorderDemand = _interopRequireWildcard(require("@ori-events/cancel-backorder-demand"));
var CancelSubscription = _interopRequireWildcard(require("@ori-events/cancel-subscription"));
var CancelSubscriptionFailed = _interopRequireWildcard(require("@ori-events/cancel-subscription-failed"));
var ClearBasket = _interopRequireWildcard(require("@ori-events/clear-basket"));
var DelaySubscription = _interopRequireWildcard(require("@ori-events/delay-subscription"));
var DelaySubscriptionFailed = _interopRequireWildcard(require("@ori-events/delay-subscription-failed"));
var DeleteOfferItem = _interopRequireWildcard(require("@ori-events/delete-offer-item"));
var DeleteOfferItemFailed = _interopRequireWildcard(require("@ori-events/delete-offer-item-failed"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var RemoveBasketItem = _interopRequireWildcard(require("@ori-events/remove-basket-item"));
var RemoveBasketItemFailed = _interopRequireWildcard(require("@ori-events/remove-basket-item-failed"));
var RemoveCustomerOrder = _interopRequireWildcard(require("@ori-events/remove-customer-order"));
var RemoveCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/remove-customer-order-failed"));
var RemoveShippingOfferItem = _interopRequireWildcard(require("@ori-events/remove-shipping-offer-item"));
var RemoveShippingOfferItemFailed = _interopRequireWildcard(require("@ori-events/remove-shipping-offer-item-failed"));
var RemoveVoucher = _interopRequireWildcard(require("@ori-events/remove-voucher"));
var RemoveVoucherFailed = _interopRequireWildcard(require("@ori-events/remove-voucher-failed"));
var ReplaceShoppingBagItem = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item"));
var ReplaceShoppingBagItemFailed = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item-failed"));
var ReplaceSubscription = _interopRequireWildcard(require("@ori-events/replace-subscription"));
var ReplaceSubscriptionFailed = _interopRequireWildcard(require("@ori-events/replace-subscription-failed"));
var RequestShoppingContext = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ResetShippingSelection = _interopRequireWildcard(require("@ori-events/reset-shipping-selection"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var UpdateBasketItem = _interopRequireWildcard(require("@ori-events/update-basket-item"));
var UpdateBasketItemFailed = _interopRequireWildcard(require("@ori-events/update-basket-item-failed"));
var UpdateCustomerOrderItem = _interopRequireWildcard(require("@ori-events/update-customer-order-item"));
var UpdateCustomerOrderItemFailed = _interopRequireWildcard(require("@ori-events/update-customer-order-item-failed"));
var UpdateDelivery = _interopRequireWildcard(require("@ori-events/update-delivery"));
var UpdateDeliveryChannel = _interopRequireWildcard(require("@ori-events/update-delivery-channel"));
var UpdateDeliveryChannelFailed = _interopRequireWildcard(require("@ori-events/update-delivery-channel-failed"));
var UpdateDeliveryFailed = _interopRequireWildcard(require("@ori-events/update-delivery-failed"));
var UpdateDonation = _interopRequireWildcard(require("@ori-events/update-donation"));
var UpdateDonationFailed = _interopRequireWildcard(require("@ori-events/update-donation-failed"));
var UpdateOfferItem = _interopRequireWildcard(require("@ori-events/update-offer-item"));
var UpdateOfferItemFailed = _interopRequireWildcard(require("@ori-events/update-offer-item-failed"));
var UpdateOfferItems = _interopRequireWildcard(require("@ori-events/update-offer-items"));
var UpdatePaymentProvider = _interopRequireWildcard(require("@ori-events/update-payment-provider"));
var UpdatePaymentProviderFailed = _interopRequireWildcard(require("@ori-events/update-payment-provider-failed"));
var _handlers = require("../handlers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Configuration of shopping context actions. Mapping of triggering events to response
 * success & failed events and event handlers for the responses.
 */
const shoppingContextActions = exports.shoppingContextActions = new Map([[AcceptNotification.Name, {
  failedEvent: AcceptNotificationFailed.Name,
  handler: _handlers.acceptNotificationHandler
}], [AddBackorderDemand.Name, {
  failedEvent: AddBackorderDemandFailed.Name,
  handler: _handlers.addBackorderDemandHandler
}], [AddBasketOffer.Name, {
  failedEvent: AddBasketOfferFailed.Name,
  handler: _handlers.addBasketOfferHandler
}], [AddCatalogueOffer.Name, {
  failedEvent: AddCatalogueOfferFailed.Name,
  handler: _handlers.addCatalogueOfferHandler
}], [AddCustomerOrder.Name, {
  failedEvent: AddCustomerOrderFailed.Name,
  handler: _handlers.addCustomerOrderHandler
}], [AddFreeShippingOffer.Name, {
  failedEvent: AddFreeShippingOfferFailed.Name,
  handler: _handlers.addFreeShippingOfferHandler
}], [AddPersonalNutritionItems.Name, {
  failedEvent: AddPersonalNutritionItemsFailed.Name,
  handler: _handlers.addPersonalNutritionItemsHandler
}], [AddPersonalSubscription.Name, {
  failedEvent: AddPersonalSubscriptionFailed.Name,
  handler: _handlers.addPersonalSubscriptionHandler
}], [AddToBasket.Name, {
  failedEvent: AddToBasketFailed.Name,
  handler: _handlers.addToBasketHandler
}], [AddVoucher.Name, {
  failedEvent: AddVoucherFailed.Name,
  handler: _handlers.addVoucherHandler
}],
// TODO -- no failed event available so far for CancelBackorderDemand
[CancelBackorderDemand.Name, {
  handler: _handlers.cancelBackorderDemandHandler
}], [CancelSubscription.Name, {
  failedEvent: CancelSubscriptionFailed.Name,
  handler: _handlers.cancelSubscriptionHandler
}],
// TODO -- no failed event available so far for ClearBasket
[ClearBasket.Name, {
  handler: _handlers.clearBasketHandler
}], [DelaySubscription.Name, {
  failedEvent: DelaySubscriptionFailed.Name,
  handler: _handlers.delaySubscriptionHandler
}], [DeleteOfferItem.Name, {
  failedEvent: DeleteOfferItemFailed.Name,
  handler: _handlers.deleteOfferItemHandler
}],
// TODO -- solve better the possible cases for LoyaltyDialogResult - maybe add-to-basket-failed,
// and don't set up the loading state when just closed dialog (so exception to check for this case)
[LoyaltyDialogResult.Name, {
  handler: _handlers.checkLoyaltyDialogResultAndAddToBasketHandler
}], [RemoveBasketItem.Name, {
  failedEvent: RemoveBasketItemFailed.Name,
  handler: _handlers.removeBasketItemHandler
}], [RemoveCustomerOrder.Name, {
  failedEvent: RemoveCustomerOrderFailed.Name,
  handler: _handlers.removeCustomerOrderHandler
}], [RemoveShippingOfferItem.Name, {
  failedEvent: RemoveShippingOfferItemFailed.Name,
  handler: _handlers.removeShippingOfferItemHandler
}], [RemoveVoucher.Name, {
  failedEvent: RemoveVoucherFailed.Name,
  handler: _handlers.removeVoucherHandler
}], [ReplaceShoppingBagItem.Name, {
  failedEvent: ReplaceShoppingBagItemFailed.Name,
  handler: _handlers.replaceShoppingBagItemHandler
}], [ReplaceSubscription.Name, {
  failedEvent: ReplaceSubscriptionFailed.Name,
  handler: _handlers.replaceSubscriptionHandler
}], [RequestShoppingContext.Name, {
  successEvent: ShoppingContextLoaded.Name,
  handler: _handlers.requestShoppingContextHandler
}],
// TODO -- no failed event available so far for ResetShippingSelection
[ResetShippingSelection.Name, {
  handler: _handlers.resetShippingSelectionHandler
}], [UpdateBasketItem.Name, {
  failedEvent: UpdateBasketItemFailed.Name,
  handler: _handlers.updateBasketItemHandler
}], [UpdateCustomerOrderItem.Name, {
  failedEvent: UpdateCustomerOrderItemFailed.Name,
  handler: _handlers.updateCustomerOrderItemHandler
}], [UpdateDelivery.Name, {
  failedEvent: UpdateDeliveryFailed.Name,
  handler: _handlers.updateDeliveryHandler
}], [UpdateDeliveryChannel.Name, {
  failedEvent: UpdateDeliveryChannelFailed.Name,
  handler: _handlers.updateDeliveryChannelHandler
}], [UpdateDonation.Name, {
  failedEvent: UpdateDonationFailed.Name,
  handler: _handlers.updateDonationHandler
}], [UpdateOfferItem.Name, {
  failedEvent: UpdateOfferItemFailed.Name,
  handler: _handlers.updateOfferItemHandler
}],
// TODO -- no failed event available so far for UpdateOfferItems
[UpdateOfferItems.Name, {
  handler: _handlers.updateOfferItemsHandler
}], [UpdatePaymentProvider.Name, {
  failedEvent: UpdatePaymentProviderFailed.Name,
  handler: _handlers.updatePaymentProviderHandler
}]]);
